:host {
  box-sizing: border-box;
  --uui-col-padding-left: calc(var(--uui-grid-spacing) / 2);
  --uui-col-padding-right: calc(var(--uui-grid-spacing) / 2);
  padding-left: var(--uui-col-padding-left);
  padding-right: var(--uui-col-padding-right);
  padding-bottom: calc(var(--uui-grid-spacing) / 2 * 2);
  max-width: 100%;
}
/* Breakpoints */
@media (max-width: 576px) {
  /* xs */
  @for $i from 1 through 12 {
    .uui-col-xs-#{$i} {
      flex: 0 0 #{'calc(100% * #{$i} / var(--uui-grid-columns))'};
    }

    :host([xs="#{$i}"]) {
      flex: 0 0 #{'calc(100% * #{$i} / var(--uui-grid-columns))'};
    }
  }
}

@media (min-width: 577px) and (max-width: 991px) {
  /* s */
  @for $i from 1 through 12 {
    .uui-col-s-#{$i} {
      flex: 0 0 #{'calc(100% * #{$i} / var(--uui-grid-columns))'};
    }

    :host([s="#{$i}"]) {
      flex: 0 0 #{'calc(100% * #{$i} / var(--uui-grid-columns))'};
    }
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  /* m */
  @for $i from 1 through 12 {
    .uui-col-m-#{$i} {
      flex: 0 0 #{'calc(100% * #{$i} / var(--uui-grid-columns))'};
    }

    :host([m="#{$i}"]) {
      flex: 0 0 #{'calc(100% * #{$i} / var(--uui-grid-columns))'};
    }
  }
}

@media (min-width: 1200px) {
  /* l */
  @for $i from 1 through 12 {
    .uui-col-l-#{$i} {
      flex: 0 0 #{'calc(100% * #{$i} / var(--uui-grid-columns))'};
    }

    :host([l="#{$i}"]) {
      flex: 0 0 #{'calc(100% * #{$i} / var(--uui-grid-columns))'};
    }
  }
}
